import React, { useState, useEffect } from 'react';
import {map, startCase} from "lodash";
import {durationSortComparator, formatFullDate, getErrorMessage} from "utility/helpers/utils";
import { getTimeOff,  } from "utility/apis/ConfigService";
import { TABLES_NAMES } from "utility/constants/constants";
import {Button, DataGridTable, DateTimePicker, Dialog, Select, Tooltip, DialogActions, GridActionsCellItem} from "components/Mui";
import Loading from "components/Loading/Loading";
import StatusCard from "components/StatusCard/StatusCard";
import {CancelIcon, DeleteIcon, EditIcon, RedoIcon} from "components/Mui/Icons";
import {Controller, useForm} from "react-hook-form";
import moment from "moment";
import {DAY_MONTH_FORMAT, FULL_DATE_ISO_FORMAT, TIME_FORMAT} from "utility/helpers/metaData";
import {
    cancelTimeOffRequest,
    convertTimeOffRequest, deleteTimeOffRequest,
    updateTimeOffRequest
} from "utility/apis/EmployeeService";
import {
    CONFIRMATION_MODAL,
    TIME_OFF_CANCEL_REQUEST_MODAL,
    TIME_OFF_CONVERT_REQUEST_MODAL,
    TIME_OFF_REQUEST_MODAL
} from "utility/modals/constants";
import {wfhOptions} from "utility/constants/data";
import WithModals from "hoc/withModals/withModals";

import "./WfhAllRecords.scss";
import {toast} from "react-toastify";

const WfhAllRecords = (props) => {
    const { employeeId, date, message, colorTheme, modals, toggleTimeOffEditModal, toggleConfirmationModal, toggleTimeOffCancelModal, toggleTimeOffConvertModal, contractId } = props;

    const [ inProgress, setInProgress ] = useState(false);
    const [ statusCard, setStatusCard ] = useState(undefined);
    const [dataTable, setDataTable] = useState([]);
    const [selectedTimeOffRequest, setSelectedTimeOffRequest] = useState({});
    const [fromDate, setFromDate] = useState();
    const [toDate, setToDate] = useState();
    const [isInProgress, setIsInProgress] = useState(false);
    const {  control, handleSubmit } = useForm({defaultValues: {}});

    const fetchData = async () => {
        setInProgress(true);
        try {
            const response = await getTimeOff(employeeId, moment.isMoment(date)? moment(date).format("YYYY") : date?.value, 'wfh', undefined, contractId);
            const data = formatDataTable(response?.data?.mergedVacations);
            setStatusCard({
                'WFH': response?.data?.usedWfh,
                'Rejected': response?.data?.rejectedWfh
            });
            setDataTable(data);
        } catch (e) {
        }
        setInProgress(false);
    }

    useEffect(() => {
        if (date) {
            fetchData();
        }
    }, [date, contractId]);

    const formatDataTable = (data) => {
        return map(data, ({ fromDate, toDate, hours, value, minutes, mergedVacation, vacationLengthLabel }, index) => {
            const newMergedVacations = {
                state: [],
                approver: [],
                comments: []
            };
            map(mergedVacation, ({ vacationState, attendanceState, teamManagerApprovals, comments }) =>  {
                newMergedVacations.state.push(attendanceState || vacationState);
                newMergedVacations.comments.push(comments);
                if (teamManagerApprovals) {
                    teamManagerApprovals.forEach((teamManagerApproval) => {
                        newMergedVacations.approver.unshift(...map(teamManagerApproval?.managerApprovalSet, ({
                         state,
                         managerName,
                         comments
                        }) => ({
                            managerName,
                            state,
                            comments
                        })));
                    });
                }
            });
            return {
                id: index,
                fromDate: formatFullDate(fromDate),
                toDate: formatFullDate(toDate),
                details: vacationLengthLabel,
                state: newMergedVacations.state,
                approver: newMergedVacations.approver,
                comments: newMergedVacations.comments,
                mergedVacation
            }
        });
    }

    const columnDefs = [
        {
            headerName: 'Details',
            field: 'details',
            flex: 1.5,
            sortable: true,
            valueGetter: (params) => params?.value || '',
            sortComparator: durationSortComparator
        },
        {
            headerName: 'From Date',
            field: 'fromDate',
            flex: 1.6,
        },
        {
            headerName: 'To Date',
            field: 'toDate',
            flex: 1.6,
        },
        {
            headerName: 'Approver',
            field: 'approver',
            renderCell: (params) => (
                <div className="ellipsis">
                    {params.value?.map(({ state, managerName }) => (
                        <Tooltip title={`${startCase(managerName)}: ${startCase(state)}`}>
                            <div className="ellipsis">
                                <span>{startCase(managerName)}: </span>
                                <span className={state.indexOf('Rejected') > -1 ? "text-danger" : "text-info"}>{startCase(state)}</span>
                            </div>
                        </Tooltip>
                    ))}
                    {/*<span className={`ms-2 ${params.row.approver >= 0 ? "text-success" : "text-danger"}`}>*/}
                    {/*    {params.row.approver}*/}
                    {/*</span>*/}
                </div>
            ),
            flex: 2,
            sortable: false,
        },
        {
            headerName: 'Submitted By',
            field: 'byWhome',
            flex: 1.4,
            valueGetter: (params) => params.row?.mergedVacation?.[0]?.byWhome || '',
            renderCell: (params) => (
                <div className="ellipsis">
                    <Tooltip title={params?.row?.mergedVacation[0]?.byWhome}>
                        <div className="label-font ellipsis">{params?.row?.mergedVacation[0]?.byWhome}</div>
                    </Tooltip>
                </div>

            ),
            sortable: true,
        },
        {
            headerName: 'Final State',
            field: 'state',
            flex: 1,
            renderCell: (params) => (
                <div className="ellipsis">
                    {params.value?.map((text) => (
                        <Tooltip title={startCase(text)}>
                            <div className={`ellipsis ${text.indexOf('Rejected') > -1 ? "text-danger" : "text-info"}`}>{startCase(text)}</div>
                        </Tooltip>
                    ))}
                </div>
            ),
        },
        {
            headerName: 'Comments',
            field: 'comments',
            flex: 1.5,
            valueGetter: (params) => {
                return (params.row?.comments || []).join(' ').toLowerCase();
            },
            renderCell: (params) => (
                <div className="ellipsis">
                    {(params.row?.comments || []).map((text, index) => (
                        <>
                            {text &&
                                <Tooltip title={startCase(text)} key={index}>
                                    <div className="ellipsis">{startCase(text)}</div>
                                </Tooltip>
                            }
                        </>
                    ))}
                </div>
            ),
        },
        {
            headerName: 'Actions',
            field: 'actions',
            type: 'actions',
            width: 80,
            getActions: (params) => {
                const actions = [];
                actions.push(
                    <GridActionsCellItem showInMenu icon={<EditIcon />} onClick={(event) => handleEditClick(event, params)} label="Edit" />,
                    <GridActionsCellItem showInMenu icon={<RedoIcon />} onClick={(event) => handleConvertClick(event, params)} label="Convert vacation" />,
                    <GridActionsCellItem sx={Number(date?.value) !== moment().year()? {'color': '#cdcdcd', 'cursor': 'default'} : null} showInMenu icon={<CancelIcon sx={Number(date?.value) !== moment().year()? {'color': '#cdcdcd', 'cursor': 'default'} : null}/>}
                         onClick={(event) => {
                             if (Number(date?.value) !== moment().year()) {
                                 event.stopPropagation();
                                 return;
                             }
                             handleCancelClick(event, params);
                         }}
                    label="Cancel request" />,
                    <GridActionsCellItem sx={Number(date?.value) !== moment().year()? {'color': '#cdcdcd !important', 'cursor': 'default'} : null} showInMenu icon={<DeleteIcon sx={Number(date?.value) !== moment().year()? {'color': '#cdcdcd !important', 'cursor': 'default'} : null}/>}
                         onClick={(event) => {
                             if (Number(date?.value) !== moment().year()) {
                                 event.stopPropagation();
                                 return;
                             }
                             handleDeleteClick(event, params);
                         }}
                    label="Delete" className="text-danger" />
                );
                return actions;
            },
        }
    ];

    const handleEditClick = (event, params) => {
        setSelectedTimeOffRequest(params.row);
        setFromDate(moment(params.row.fromDate));
        setToDate(moment(params.row.toDate));
        toggleTimeOffEditModal();
    }

    const handleConvertClick = (event, params) => {
        setSelectedTimeOffRequest(params.row);
        toggleTimeOffConvertModal();
    }

    const handleCancelClick = (event, params) => {
        setSelectedTimeOffRequest(params.row);
        toggleTimeOffCancelModal();
    }
    const handleDeleteClick = (event, params) => {
        setSelectedTimeOffRequest(params.row);
        toggleConfirmationModal();
    }

    const handleTimeOffRequestUpdate = async (event, data) => {
        setIsInProgress(true);
        event.preventDefault();
        try {
            const {  toDate, fromDate } = data;
            const formattedFormDate = fromDate.format(FULL_DATE_ISO_FORMAT) + "Z";
            const formattedToDate = toDate.format(FULL_DATE_ISO_FORMAT) + "Z";

            const payload = {
                from: formattedFormDate,
                to: formattedToDate,
                employee_id: employeeId,
                type: selectedTimeOffRequest?.mergedVacation[0]?.type
            };
            await updateTimeOffRequest(selectedTimeOffRequest?.mergedVacation[0]?.id, payload);
            toast.success("Updated Successfully");
            refreshData();
            toggleTimeOffEditModal();
        } catch (e) {
            toast.error(getErrorMessage(e));
        }finally {
            setTimeout(() => {
                setIsInProgress(false);
            }, 2000);
        }
    }
    const handleTimeOffRequestConvert = async (data) => {
        setIsInProgress(true);
        try {
            await convertTimeOffRequest(selectedTimeOffRequest?.mergedVacation[0]?.id, data.timeOffOption);
            toast.success("Converted Successfully");
            refreshData();
            toggleTimeOffConvertModal();
        } catch (e) {
            toast.error(getErrorMessage(e));
        }finally {
            setTimeout(() => {
                setIsInProgress(false);
            }, 2000);
        }
    }
    const handleTimeOffRequestCancel = async () => {
        setIsInProgress(true);
        try {
            await cancelTimeOffRequest(selectedTimeOffRequest?.mergedVacation[0]?.id);
            toast.success("Canceled Successfully");
            refreshData();
            toggleTimeOffCancelModal();
        } catch (e) {
            toast.error(getErrorMessage(e));
        }finally {
            setTimeout(() => {
                setIsInProgress(false);
            }, 2000);
        }
    }
    const handleTimeOffRequestDelete = async () => {
        setIsInProgress(true);
        try {
            await deleteTimeOffRequest(selectedTimeOffRequest?.mergedVacation[0]?.id);
            toast.success("Deleted Successfully");
            refreshData();
            toggleConfirmationModal();
        } catch (e) {
            toast.error(getErrorMessage(e));
        }finally {
            setTimeout(() => {
                setIsInProgress(false);
            }, 2000);
        }
    }

    const refreshData = () => {
        fetchData() ;
    }

    return (
        <div id="WfhAllRecords" className="c-wfh-all-records ps-4">
            {inProgress ?
                <Loading></Loading>
                :
                <div className="container-fluid">
                    {!!statusCard &&
                        <StatusCard status={statusCard} colClassName="col-6"/>
                    }
                    <div style={{height: `calc(100vh - ${message ? 308 : 230}px)`}} className="row">
                        <DataGridTable
                            className="col-12"
                            key={TABLES_NAMES.WFH_LIST}
                            columns={columnDefs}
                            dataTable={dataTable}
                            isExport={false}
                        />
                    </div>
                </div>
            }
            <Dialog className='time-off-request-dialog' open={modals[TIME_OFF_REQUEST_MODAL]} toggle={toggleTimeOffEditModal}>
                <form onSubmit={(event) => handleTimeOffRequestUpdate(event, { toDate, fromDate })}>
                    <div className="m-4">
                        <h6 className="mb-4" style={{color: colorTheme}}>Edit Time Off Request</h6>
                        <div className="column">
                            <DateTimePicker
                                name="fromDateTime"
                                label="From Date"
                                className="mx-1"
                                value={fromDate}
                                onChange={(newValue) => setFromDate(newValue)}
                            />
                            <DateTimePicker
                                name="toDateTime"
                                label="To Date"
                                className="mx-1"
                                value={toDate}
                                minDateTime={fromDate}
                                onChange={(newValue) => setToDate(newValue)}
                            />
                        </div>
                    </div>
                    <div>
                        <DialogActions className="p-3 mt-3">
                            <Button className="px-4 me-3" variant="outlined" onClick={toggleTimeOffEditModal}>Cancel</Button>
                            <Button className="px-4" variant="contained" type="submit" disabled={isInProgress}>Save</Button>
                        </DialogActions>
                    </div>
                </form>
            </Dialog>
            <Dialog className='confirmation-dialog' open={modals[TIME_OFF_CONVERT_REQUEST_MODAL]} toggle={toggleTimeOffConvertModal}>
                <form onSubmit={handleSubmit(handleTimeOffRequestConvert)}>
                    <div className="m-4" style={{color: colorTheme}}>
                        {selectedTimeOffRequest.details} leave on {moment(selectedTimeOffRequest.fromDate).format(DAY_MONTH_FORMAT)} ({moment(selectedTimeOffRequest.fromDate).format(TIME_FORMAT)} to {moment(selectedTimeOffRequest.toDate).format(TIME_FORMAT)})
                    </div>
                    <div className="m-4">
                        <Controller
                            as={
                                <Select options={wfhOptions} />
                            }
                            id="timeOffOption"
                            name="timeOffOption"
                            control = {control}
                            defaultValue={wfhOptions[0].value}
                        />
                    </div>
                    <div>
                        <DialogActions className="p-3 mt-3">
                            <Button className="px-4 me-3" variant="outlined" onClick={toggleTimeOffConvertModal}>Cancel</Button>
                            <Button className="px-4" variant="contained" type="submit" disabled={isInProgress}>Confirm</Button>
                        </DialogActions>
                    </div>
                </form>
            </Dialog>
            <Dialog className='confirmation-dialog' open={modals[TIME_OFF_CANCEL_REQUEST_MODAL]} toggle={toggleTimeOffCancelModal}>
                <div>
                    <div className="m-4">
                        Are you sure you want to cancel{' '}
                        <span style={{color: colorTheme}}>
                            {selectedTimeOffRequest.details} leave on {moment(selectedTimeOffRequest.fromDate).format(DAY_MONTH_FORMAT)} ({moment(selectedTimeOffRequest.fromDate).format(TIME_FORMAT)} to {moment(selectedTimeOffRequest.toDate).format(TIME_FORMAT)})
                        </span>
                        ?
                    </div>
                    <div className="m-4 fw-light">
                        Note: Cancellation requests require approval from managers
                    </div>
                    <div>
                        <DialogActions className="p-3 mt-3">
                            <Button className="px-4 me-3" variant="outlined"
                                    onClick={toggleTimeOffCancelModal}>Cancel</Button>
                            <Button className="px-4" variant="contained"
                                    onClick={handleTimeOffRequestCancel} disabled={isInProgress}>Confirm</Button>
                        </DialogActions>
                    </div>
                </div>
            </Dialog>
            <Dialog className='confirmation-dialog' open={modals[CONFIRMATION_MODAL]} toggle={toggleConfirmationModal}>
                <div>
                    <div className="m-4" style={{color: colorTheme}}>
                        Are you sure you want to delete this ?
                    </div>
                    <div>
                        <DialogActions className="p-3 mt-3">
                            <Button className="px-4 me-3" variant="outlined"
                                    onClick={toggleConfirmationModal}>Cancel</Button>
                            <Button className="px-4 bg-danger" color="secondary" variant="outlined" disabled={isInProgress}
                                    onClick={handleTimeOffRequestDelete}>Delete</Button>
                        </DialogActions>
                    </div>
                </div>
            </Dialog>
        </div>
    );
};

const modalsProps = {
    toggleTimeOffEditModal: TIME_OFF_REQUEST_MODAL,
    toggleTimeOffConvertModal: TIME_OFF_CONVERT_REQUEST_MODAL,
    toggleTimeOffCancelModal: TIME_OFF_CANCEL_REQUEST_MODAL,
    toggleConfirmationModal: CONFIRMATION_MODAL
};
export default WithModals(WfhAllRecords, modalsProps);
